
import { loginConfirmedAction, logoutpath } from "../store/actions/AuthActions";
import Swal from "../components/SystemAlert";
export function formatError(errorResponse) {
switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      Swal.fire("Error", "El correo electrónico ya existe.", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      Swal.fire("Error", "No se encontró el correo electrónico.", "error");
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      Swal.fire("Error", "La contraseña no es válida.", "error");
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + 10000000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
  setTimeout(() => {
    dispatch(logoutpath(history));
  }, timer);
}

export function checkAutoLogin(dispatch, history) {
  const tokenDetailsString = localStorage.getItem("token");
  if (!tokenDetailsString) {
    dispatch(logoutpath(history));
    return;
  }
  let expireDate =  new Date(localStorage.getItem("expiration"))
  let todaysDate = new Date();
  if (todaysDate > expireDate) {
    dispatch(logoutpath(history));
    return;
  }
  dispatch(loginConfirmedAction({ idToken: tokenDetailsString }));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, history);
}
